import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useRouteMatch } from 'react-router-dom';
import { fetchApplication, fetchAppsNavData, refreshToken, setAppInfo } from "..";

export default (function (_ref) {
    var appId = _ref.appId,
        app = _ref.app,
        children = _ref.children;

    var loggedIn = useSelector(function (state) {
        return state.header.auths.loggedIn;
    });
    var appLoaded = useSelector(function (state) {
        return state.header.app.loaded;
    });
    var dispatch = useDispatch();

    var loginInProgress = useRouteMatch({
        path: '/oauth2/callback',
        exact: true
    }) || useRouteMatch({
        path: '/login',
        exact: true
    });

    useEffect(function () {
        if (!loggedIn && !loginInProgress) {
            dispatch(refreshToken());
        }
    }, [dispatch, loggedIn, loginInProgress]);

    useEffect(function () {
        dispatch(setAppInfo(app));
        dispatch(fetchApplication(appId));
    }, [dispatch, appId, app]);

    useEffect(function () {
        if (loggedIn) {
            dispatch(fetchAppsNavData(appId));
        }
    }, [loggedIn, appId]);

    if (appLoaded) {
        return React.createElement(
            Fragment,
            null,
            children
        );
    } else {
        return React.createElement(
            'div',
            null,
            'Loading application...'
        );
    }
});